import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/journal-entries')({
  staticData: { crumb: 'journals' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'ledger.read'),
  component: Outlet,
})
